import React from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Box, Tooltip } from '@mui/material';
import { Add, Person } from '@mui/icons-material';
import { CarModel } from 'models/StockModel';
import { CompanyType } from 'models/CompanyModel';
import { PartyModel, PartyType } from 'models/PartyModel';
import usePartyModals from 'modules/parties/hooks/usePartyModals';
import auth from 'recoil/atoms/auth';


type PartyProps = {
    car: CarModel,
    type: PartyType,
    party: PartyModel,
    compact?: boolean,
}

const PartyButton = React.memo(({car, party, type, compact}: PartyProps) => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation('cars');
    const {openAddPartyModal, openEditPartyModal} = usePartyModals();

    if (my.type !== CompanyType.Master && car.voyage?.pod.country === 'KR')
        return null

    const canEdit = !(type === PartyType.Dealer && my.type === CompanyType.Shipper);

    if (party)
        return (
            <Tooltip
                title={t('edit')}
                placement="top"
            >
                {compact ?
                    <Person onClick={() => canEdit && openEditPartyModal(party)}/> :
                    <Box
                        onClick={() => canEdit && openEditPartyModal(party)}
                        sx={{cursor: 'pointer'}}
                    >
                        {party.shortName || 'Unnamed'}
                    </Box>
                }
            </Tooltip>
        );

    if (!my.permissions.has(`parties create ${type}`))
        return null;

    return (
        <Tooltip
            title={`${t('add')} ${type}`}
            placement="top"
        >
            <Add
                onClick={() => openAddPartyModal('car', car.id, type, Object.values(car.parties).map(p => p?.email))}
            />
        </Tooltip>
    )
});

export default PartyButton;
